<template>
    <div class="p-3">
        <h3>Rekapitulasi Daftar Rujukan</h3>
        <hr />
        <DataTable
            table-id="table-pasien"
            title="Rekapitulasi Daftar Rujukan"
            :filter-configs="filterConfigs"
            :table-options="tableOptions"
            :show-filter="true"
        />
    </div>
</template>

<script>
import DataTable from "@/components/global/DataTable.vue";

export default {
    components: {
        DataTable,
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: "start_date",
                    label: "Tanggal Awal",
                    field: "start_date",
                    type: "date",
                    colClass: "col-sm-3",
                    component: "",
                },
                {
                    id: "end_date",
                    label: "Tanggal Akhir",
                    field: "end_date",
                    type: "date",
                    colClass: "col-sm-3",
                    component: "",
                },
            ],
            tableOptions: {
                baseUrl: "/api/rekapitulasi-pelayanan/daftar-rujukan",
                layout: "fitDataStretch",
                responsiveLayout: "collapse",
                columnMinWidth: 80,
                columns: [
                    {
                        title: "No.",
                        field: "no",
                        hozAlign: "center",
                        formatter: "rownum",
                    },
                    {
                        title: "NOREG",
                        field: "NOREG",
                    },
                    {
                        title: "NO RM",
                        field: "NO_RM",
                    },
                    {
                        title: "NAMA",
                        field: "NAMA",
                    },
                    {
                        title: "KODE POLI",
                        field: "KODE_POLI",
                    },
                    {
                        title: "NAMA POLI",
                        field: "NAMA_POLI",
                    },
                    {
                        title: "TGL BEROBAT",
                        field: "TGL_BEROBAT",
                    },
                    {
                        title: "KODE RUJUKAN",
                        field: "KODE_RUJUKAN",
                    },
                    {
                        title: "NAMA RUJUKAN",
                        field: "NAMA_RUJUKAN",
                        hozAlign: "center",
                    },
                    {
                        title: "INSTALASI",
                        field: "INSTALASI",
                        hozAlign: "center",
                    },
                ],
                ajaxResponse: (url, params, response) => response.data,
            },
        };
    },
};
</script>
